var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isWebAgent)?_c('div',[_vm._t("default")],2):_c('mescroll-vue',{ref:"mescroll",attrs:{"down":_vm.mescrollDown,"up":_vm.mescrollUp},on:{"init":_vm.mescrollInit}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-325b8cee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/MescrollWrapper.vue
// module id = null
// module chunks = 